import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'categoria'
})
export class CategoriaPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        } if (value  ===  1) {
            return 'Ativo';
        } if (value  ===  2) {
            return 'Assistido';
        } if (value  ===  3) {
            return 'Cancelado';
        }
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/pipe/categoria.pipe.ts